import React, { useEffect, useMemo, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import './WorkshopsCertificates.css';

function WorkshopsCertificateLookup() {
  const [searchParams] = useSearchParams();
  const certToken = searchParams.get('cert_token') || searchParams.get('token') || '';
  const [record, setRecord] = useState(null);
  const [loading, setLoading] = useState(false);
  const [statusMessage, setStatusMessage] = useState('');

  const baseURL = useMemo(() => `${process.env.REACT_APP_BASE_URL}crm/`, []);

  useEffect(() => {
    async function fetchCertificate() {
      if (!certToken) {
        setRecord(null);
        setStatusMessage('No se encontró un token de certificado.');
        return;
      }
      setLoading(true);
      setStatusMessage('');
      try {
        const data = new FormData();
        data.append('cert_token', certToken);
        const response = await fetch(`${baseURL}get/get_cert_validation.php`, {
          method: 'POST',
          body: data
        });
        const text = await response.text();
        if (text === 'NOT_FOUND' || text === 'MISSING_PARAMS') {
          setRecord(null);
          setStatusMessage('No se encontró el certificado solicitado.');
          return;
        }
        const parsed = JSON.parse(text);
        setRecord(parsed);
      } catch (error) {
        console.error('Error cargando certificado:', error);
        setStatusMessage('Ocurrió un error al consultar el certificado.');
      } finally {
        setLoading(false);
      }
    }

    fetchCertificate();
  }, [certToken, baseURL]);

  const formatDate = (dateValue) => {
    if (!dateValue) {
      return '';
    }
    const parsed = new Date(dateValue.replace(' ', 'T'));
    if (Number.isNaN(parsed.getTime())) {
      return dateValue;
    }
    return parsed.toLocaleDateString('es-ES', {
      day: '2-digit',
      month: 'long',
      year: 'numeric'
    });
  };

  return (
    <div className="workshop-cert-page">
      <div className="workshop-card cert-lookup-card">
        {loading ? (
          <div className="text-muted">Cargando...</div>
        ) : record ? (
          <>
            <div className="cert-status">
              <div className="cert-badge">Certificado válido</div>
              <div className="cert-subtitle">Validación por token</div>
            </div>
            <h1 className="workshop-title">{record.workshop_name}</h1>
            <div className="workshop-date">Emitido: {formatDate(record.vote_date)}</div>

            <div className="cert-grid">
              <div className="cert-panel">
                <h3>Participante</h3>
                <div className="text-muted">{record.voter_name || '-'}</div>
                <div className="text-muted">{record.voter_email || '-'}</div>
              </div>
              <div className="cert-panel">
                <h3>Datos del taller</h3>
                <div className="text-muted">Fecha: {formatDate(record.event_date)}</div>
                {record.event_goals && (
                  <div className="text-muted">Objetivos: {record.event_goals}</div>
                )}
                {record.event_link ? (
                  <a className="workshop-link" href={record.event_link} target="_blank" rel="noreferrer">
                    ▶ Ver en YouTube
                  </a>
                ) : (
                  <div className="text-muted">Sin link de video.</div>
                )}
              </div>
              <div className="cert-panel">
                <h3>Token de verificación</h3>
                <div className="text-muted cert-token">{record.cert_token}</div>
              </div>
            </div>
          </>
        ) : (
          <div className="text-muted">{statusMessage || 'No se encontró el certificado solicitado.'}</div>
        )}
      </div>
    </div>
  );
}

export default WorkshopsCertificateLookup;
